import IonIcon from '@reacticons/ionicons'
import Link from 'next/link'
import React from 'react'

interface IconLinkProps {
  url: string
}

export const IconLinkLinkedin: React.FC<IconLinkProps> = ({ url }) => {
  return (
    <Link
      href={url}
      target="_blank"
      className="flex flex-row items-center cursor-pointer mr-[0.625rem] font-primary text-[16px] font-bold !color-"
    >
      <IonIcon name="logo-linkedin" className={'text-[1.5rem] text-[#0077b5]'} />
    </Link>
  )
}
